const genderLookup = {
	'M': 'Male',
	'F': 'Female',
	'U': 'Unknown',
}

const employeeTypes = {
	'Full Time': 'Full Time',
	'Part Time': 'Part Time',
	'Contractor': 'Contractor',
	'Intern': 'Intern',
}

const globalGrades = {
	1: 1,
	2: 2,
	3: 3,
	4: 4,
	5: 5,
	6: 6,
	7: 7,
	8: 8,
	9: 9,
	10: 10,
	11: 11,
	12: 12,
	13: 13,
}

const formatDate = row => {
	if(row.employee_hire_date === null)
	{
		return null
	}
	return new Date(row.employee_hire_date).toLocaleDateString()
}

const getColumnColors = (row, name) =>{
	return row ? {
		backgroundColor: (row[name] === null || row[name] === '') ? 'red' : 'white',
	} : null
}

export default (jobClassificationEditComponent, jobLevelEditComponent, categoryLabels, jobLevels) => [
	{
		title: 'Row ID',
		field: 'rowCounter',
		editable: 'never',
		hidden: false,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Emp ID',
		field: 'employee_id',
		hidden: false,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'First Name',
		field: 'first_name',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Last Name',
		field: 'last_name',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Gender',
		field: 'employee_gender',
		hidden: false,
		lookup: genderLookup,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Date of Hire',
		field: 'employee_hire_date',
		hidden: false,
		render: rowData => {
			return formatDate(rowData)
		},
		type: 'date',
		defaultFilter: '',
	},
	{
		title: 'Work Type',
		field: 'employee_type',
		lookup: employeeTypes,
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Country',
		field: 'country',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Home City',
		field: 'home_city',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Home State',
		field: 'home_state',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Compensation Currency',
		field: 'compensation_local_currency',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Department',
		field: 'department',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Cost Center',
		field: 'cost_center',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Job Function',
		field: 'company_job_function',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},

	{
		title: 'Job Code',
		field: 'company_job_code',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Job Category',
		field: 'compkit_job_category',
		hidden: false,
		lookup: categoryLabels,
		editComponent: jobClassificationEditComponent,
		cellStyle: (colData, row) => {
			return {
				textAlign: 'center',
				...getColumnColors(row, 'compkit_job_category')
			}
		},
		defaultFilter: '',
	},
	{
		title: 'Job Level',
		field: 'compkit_job_level',
		hidden: false,
		lookup: jobLevels,
		editComponent: jobLevelEditComponent,
		cellStyle: (colData, row) => {
			return {
				textAlign: 'center',
				...getColumnColors(row, 'compkit_job_level')
			}
		},
		defaultFilter: '',
	},
	{
		title: 'Job Grade',
		field: 'company_job_grade',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'CompKit Job Type/Level',
		field: 'compkit_job_grade',
		editable: 'never',
		hidden: false,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'CompKit Global Grade',
		field: 'compkit_hierarchy',
		editable: 'never',
		hidden: false,
		lookup: globalGrades,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Job Title',
		field: 'company_job_title',
		cellStyle: {
			width: 250,
			textAlign: 'center',
		},
		hidden: false,
		defaultFilter: '',
	},
	{
		title: "Manager's Job Title",
		field: 'company_reporting_manager',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name I',
		field: 'company_manager_1',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name II',
		field: 'company_manager_2',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name III',
		field: 'company_manager_3',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name IV',
		field: 'company_manager_4',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name V',
		field: 'company_manager_5',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Manager Name VI',
		field: 'company_manager_6',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Annual Base Salary',
		field: 'annual_base_salary',
		hidden: false,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Date of Last Base Salary Change',
		field: 'date_of_last_base_salary_change',
		render: rowData => new Date(rowData.employee_hire_date).toLocaleDateString(),
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		type: 'date',
		defaultFilter: '',
	},
	{
		title: 'Target Incentive %',
		field: 'target_incentive_perc',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Target Incentive Local Currency',
		field: 'target_incentive_amnt',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Target Total Cash (TTC) Local Currency',
		field: 'target_total_cash',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Performance Rating',
		field: 'performance_rating',
		hidden: true,
		cellStyle: col => {
			return {
				textAlign: 'right',
				backgroundColor: isNaN(Number(col)) ? 'red' : 'white'
			}
		},
		defaultFilter: '',
	},
	{
		title: 'Survey Job Code',
		field: 'survey_job_code',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey Job Title',
		field: 'survey_job_title',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey Job Function',
		field: 'compkit_job_function',
		hidden: true,
		cellStyle: {
			textAlign: 'center'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P50 Local Currency',
		field: 'salary_p50',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Base Salary / Survey P50',
		field: 'comp_salary_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P75 Local Currency',
		field: 'salary_p75',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Base Salary / Survey P75',
		field: 'comp_salary_p75',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P50 Target Total Cash (TTC)',
		field: 'ttc_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Target Total Cash (TTC) Local Currency',
		field: 'comp_ttc_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P75 Target Total Cash',
		field: 'ttc_p75',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Target Total Cash (TTC) Local Currency',
		field: 'comp_ttc_p75',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Stock Options Granted',
		field: 'total_stock_options_granted',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Stock Options Vested',
		field: 'current_vested_equity',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Stock Options Unvested',
		field: 'current_unvested_equity',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Stock Options (% of Stock Options Granted)',
		field: 'current_unvested_percentage',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Stock Options Value Granted Local Currency',
		field: 'total_stock_options_granted_value',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Vested Stock Options Value Local Currency',
		field: 'current_vested_equity_value',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Stock Options Value Local Currency',
		field: 'current_unvested_equity_value',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P50 LTI (Ongoing) Local Currency',
		field: 'stock_options_p50',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Stock Options Value / Survey P50',
		field: 'comp_unvested_stock_options_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Survey P75 LTI (Ongoing) Local Currency',
		field: 'stock_options_p75',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Stock Options Value / Survey P75',
		field: 'comp_unvested_stock_options_p75',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Restricted Stock Units (RSUs) Granted',
		field: 'rsu_granted',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Restricted Stock Units (RSUs) Vested',
		field: 'rsu_vested',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Restricted Stock Units (RSUs) Unvested',
		field: 'rsu_unvested',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested RSUs (% of RSUs Granted)',
		field: 'rsu_unvested_percentage',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Value of RSUs Granted Local Currency',
		field: 'rsu_granted_value',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Vested RSU Value Local Currency',
		field: 'rsu_vested_value',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested RSUs Value Local Currency',
		field: 'rsu_unvested_value',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested RSUs Value / Survey P50',
		field: 'comp_rsu_unvested_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested RSUs Value / Survey P75',
		field: 'comp_rsu_unvested_p75',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Options + RSUs Value Local Currency',
		field: 'comp_unvested_stock_options_plus_rsu',
		hidden: true,
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Options + Unvested RSUs Value / P50',
		field: 'comp_unvested_stock_options_plus_rsu_p50',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
	{
		title: 'Unvested Options + Unvested RSUs Value / P75',
		field: 'comp_unvested_stock_options_plus_rsu_p75',
		hidden: true,
		editable: 'onAdd',
		cellStyle: {
			textAlign: 'right'
		},
		defaultFilter: '',
	},
]
